import { baseUrl, headers, jwtHeaders, jwtFormDataHeaders } from '../common/data';

export const getAllServiceCategories = async (branchId) => {
  const response = await fetch(`${baseUrl}/api/servicecategory/getAllServiceCategories/${branchId}`, {
    method: 'GET',
    headers: jwtHeaders(),
    redirect: 'follow',
  });
  const resData = await response?.json();
  return resData;
};

export const serviceCreateCategory = async (data) => {
  let body = data;
  let branchId = '';

  if (data instanceof FormData) {
    body = data;
    branchId = data.get('branchDetails') || data.get('branchId') || '';
  } else if (data && typeof data === 'object') {
    branchId = data.branchDetails || data.branchId || '';
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });
    body = formData;
  }

  const query = branchId
    ? `?branchId=${encodeURIComponent(branchId)}&branchDetails=${encodeURIComponent(branchId)}`
    : '';

  const response = await fetch(`${baseUrl}/api/servicecategory/createCategory${query}`, {
    method: 'POST',
    body,
    headers: jwtFormDataHeaders(),
  });
  const resData = await response?.json();
  return resData;
};

export const serviceUpdateCategory = async (categoryId, data) => {
  let body = data;
  let branchId = '';

  if (data instanceof FormData) {
    body = data;
    branchId = data.get('branchDetails') || data.get('branchId') || '';
  } else if (data && typeof data === 'object') {
    branchId = data.branchDetails || data.branchId || '';
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });
    body = formData;
  }

  const query = branchId
    ? `?branchId=${encodeURIComponent(branchId)}&branchDetails=${encodeURIComponent(branchId)}`
    : '';

  const response = await fetch(`${baseUrl}/api/servicecategory/updateCategory/${categoryId}${query}`, {
    method: 'PUT',
    body,
    headers: jwtFormDataHeaders(),
  });
  const resData = await response?.json();
  return resData;
};